var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9054 3.30385C14.2899 3.70034 14.2801 4.33343 13.8836 4.7179L9.46773 9H25C25.5523 9 26 9.44772 26 10C26 10.5523 25.5523 11 25 11H9.46773L13.8836 15.2821C14.2801 15.6666 14.2899 16.2997 13.9054 16.6961C13.5209 17.0926 12.8878 17.1024 12.4914 16.7179L6.30385 10.7179C6.10963 10.5296 6 10.2706 6 10C6 9.72945 6.10963 9.47044 6.30385 9.2821L12.4914 3.2821C12.8878 2.89763 13.5209 2.90737 13.9054 3.30385Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0946 15.3039C18.4791 14.9074 19.1122 14.8976 19.5086 15.2821L25.6961 21.2821C25.8904 21.4704 26 21.7294 26 22C26 22.2706 25.8904 22.5296 25.6961 22.7179L19.5086 28.7179C19.1122 29.1024 18.4791 29.0926 18.0946 28.6961C17.7101 28.2997 17.7199 27.6666 18.1164 27.2821L22.5323 23H7C6.44772 23 6 22.5523 6 22C6 21.4477 6.44772 21 7 21H22.5323L18.1164 16.7179C17.7199 16.3334 17.7101 15.7003 18.0946 15.3039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default __webpack_public_path__ + "static/media/icon-exchange.426b9233abebadefa8f0544555f5a5ce.svg";
export { ForwardRef as ReactComponent };